import { closeModal } from "app/slices/modalSlice";

import { useTranslation } from "react-i18next";
import { Button, ControlledSelectGray } from "components/Shared";
import { useDispatch } from "react-redux";

import { toast } from "sonner";
import { Controller, useForm } from "react-hook-form";

import { Plus as Add } from "lucide-react";
import useErrorListener from "hooks/useErrorListener";
import { TazaVerticals } from "interfaces/taza_enums";
import { useCreateTazaEntityMutation } from "api/institutional/admin_api";
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const verticalOptions = Object.values(TazaVerticals).map((vertical) => ({
  label: vertical,
  value: vertical,
}));

export const CreateTazaEntityModal = ({
  data,
}: {
  data: { user_id: string; alias?: string };
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeModal());
  };

  const {
    handleSubmit,
    control,
    formState: { isValid },
  } = useForm<{ industry_vertical: string }>({ mode: "all" });

  const [mutate, { error, isLoading }] = useCreateTazaEntityMutation();

  useErrorListener({ error });

  const doSubmit = async (values: { industry_vertical: string }) => {
    const result = await mutate({
      user_id: data.user_id,
      industry_vertical: values.industry_vertical,
    });
    if (!("error" in result)) {
      toast.success(t("Taza entity created"));
      handleClose();
    }
  };

  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{t("Create Taza Entity")}</DialogTitle>
      </DialogHeader>
      <form onSubmit={handleSubmit(doSubmit)} className="flex flex-col gap-2">
        <span className="text-sm">
          {t("Select the industry vertical for {{alias}}", {
            alias: data.alias || data.user_id,
          })}
        </span>
        <Controller
          name="industry_vertical"
          rules={{ required: true }}
          control={control}
          render={(renderProps) => (
            <ControlledSelectGray
              placeholder={t("Industry Vertical")}
              renderProps={renderProps}
              options={verticalOptions}
            />
          )}
        />

        <Button
          className="w-full"
          type="submit"
          disabled={isLoading || !isValid}
        >
          <Add />
          {t("Create Taza Entity")}
        </Button>
      </form>
    </DialogContent>
  );
};

export default CreateTazaEntityModal;
